<template>
  <nav id="menu" class="menu">
    <div class="menu__content">
      <div class="container-fluid p-0 fullheight">
        <div class="row g-0 flex-xl-row-reverse fullheight">
          <!--Menu Data Block Start -->
          <div class="col-12 col-xl-8 menu__data">
            <!-- Menu Controls Line Start -->
            <div class="menudata__controls">
              <div class="controls__content">
                <div class="container-fluid p-0">
                  <div class="row g-0">
                    <div class="col-8">
                      <div
                        class="
                          controls__leftline
                          d-flex
                          justify-content-start
                          align-items-center
                        "
                      >
                        <!-- Menu Notify Trigger Start -->
                        <a
                          id="notify-trigger-menu"
                          class="
                            btn-round-mobile btn-notify btn-light-mobile
                            hover-white hover-white-s
                          "
                          href="#0"
                        >
                          <em></em>
                          <i class="fa-solid fa-bell"></i>
                          <span class="btn-caption">Notify Me</span>
                        </a>
                        <!-- Menu Notify Trigger End -->

                        <!-- Menu Socials Start -->
                        <div class="socials-menu">
                          <ul>
                            <li>
                              <a
                                href="https://www.facebook.com/"
                                target="_blank"
                              >
                                <i class="fa-brands fa-facebook"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.instagram.com/"
                                target="_blank"
                              >
                                <i class="fa-brands fa-instagram"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.pinterest.com/"
                                target="_blank"
                              >
                                <i class="fa-brands fa-pinterest"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.behance.net/"
                                target="_blank"
                              >
                                <i class="fa-brands fa-behance"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://twitter.com/" target="_blank">
                                <i class="fa-brands fa-twitter"></i>
                              </a>
                            </li>
                            <li>
                              <a href="https://dribbble.com/" target="_blank">
                                <i class="fa-brands fa-dribbble"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <!-- Menu Socials End -->
                      </div>
                    </div>
                    <div class="col-4">
                      <div
                        class="
                          controls__rightline
                          d-flex
                          justify-content-end
                          align-items-center
                        "
                      >
                        <!-- Menu Close Button Start -->
                        <a
                          id="menu-close"
                          class="section-close hover-white hover-white-s"
                          href="#0"
                        >
                          <em></em>
                          <span></span>
                        </a>
                        <!-- Menu Close Button End -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Menu Controls Line End -->

            <!-- Menu Links Start -->
            <div class="menudata__links">
              <div class="container-fluid p-0">
                <div class="row g-0 align-items-end">
                  <div class="col-12 col-md-6">
                    <!-- Navigation Start -->
                    <ul class="navigation">
                      <li>
                        <a href="#0" id="home-trigger">Home</a>
                      </li>
                      <li>
                        <a href="#0" id="about-trigger">About Us</a>
                      </li>
                      <li>
                        <a href="#0" id="portfolio-trigger">Portfolio</a>
                      </li>
                      <li>
                        <a href="#0" id="contact-trigger">Contact</a>
                      </li>
                    </ul>
                    <!-- Navigation End -->
                  </div>
                  <div class="col-12 col-md-6">
                    <!-- Menu Contact Links Start -->
                    <ul class="menulinks__contact">
                      <li>
                        <p>
                          <a
                            class="contact-link"
                            href="https://goo.gl/maps/nWXKpGaDPuyH6gxRA"
                            target="_blank"
                            >G. Cenda at pesantren Almuhajirin,<br />Koba Bangka Tengah, KEP. Bangka Belitung</a
                          >
                        </p>
                      </li>
                      <li>
                        <p>
                          <a
                            class="contact-link"
                            href="https://goo.gl/maps/xap5o3MZBuC6DFHz8"
                            target="_blank"
                            >Grimaya<br>Pangkalpinang, KEP. Bangka Belitung</a
                          >
                        </p>
                      </li>
                      <li>
                        <p>
                                <a class="contact-link" href="tel:+6282182114366">+62 821-8211-4366</a>
                              </p>
                      </li>
                      <li>
                        <p>
                          <a
                            class="contact-link"
                            href="mailto:riskirahmand0@gmail.com?subject=Message%20from%20your%20site"
                            >riskirahmand0@gmail.com</a
                          >
                        </p>
                        <p>
                          <a
                            class="contact-link"
                            href="mailto:riskirahmand0@gmail.com?subject=Message%20from%20your%20site"
                            >riskirahmand0@gmail.com</a
                          >
                        </p>
                      </li>
                    </ul>
                    <!-- Menu Contact Links End -->
                  </div>
                </div>
              </div>
            </div>
            <!-- Menu Links End -->

            <!-- Menu Copyright Start -->
            <div class="menudata__copyright">
              <div class="container-fluid p-0">
                <div class="row g-0">
                  <div class="col-12">
                    <p class="copyright">
                      By
                      <a
                        href="https://themeforest.net/user/mix_design/portfolio"
                        target="_blank"
                        >Mix Design</a
                      >, 2022
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Menu Copyright End -->
          </div>
          <!--Menu Data Block End -->

          <!--Menu Media Block Start -->
          <div class="col-12 col-xl-4 menu__media">
            <div class="media__content">
              <!-- Menu Image Background Start -->
              <div class="menu__image menu-image-1"></div>
              <!-- Menu Image Background End -->
            </div>
          </div>
          <!--Menu Media Block End -->
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "MenuComponent",
};
</script>